import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import axios from "axios";

import Button from "../Button";

import settings from "../../config";

const ClientForm = () => {
  const navigate = useNavigate();
  const { clientId } = useParams();

  const [formData, setFormData] = useState({
    clientName: "",
    clientCode: "",
    price: 0,
    stock: 0,
  });

  useEffect(() => {
    if (clientId) {
      (async () => {
        const response = await axios.post(`${settings.api}clients/view`, {
          clientId,
        });

        if (response.data.data) {
          setFormData(response.data.data[0]);
        }
      })();
    }
  }, [clientId]);

  const onChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  return (
    <form
      onSubmit={async (e) => {
        e.preventDefault();

        const response = await axios.post(
          `${settings.api}clients/${clientId ? "update" : "create"}`,
          formData
        );

        if (response.data.statusCode === 200) {
          navigate("/clients");
        }
      }}
    >
      <div className="w-full lg:w-1/2">
        <div className="bg-white w-full rounded-xl divide-solid divide-y flex flex-col px-4">
          <div className="flex flex-col text-sm text-gray-500 py-4">
            <div className="flex flex-row justify-center space-x-10 w-full">
              <div className="w-full font-bold text-xl text-center mb-5">
                استماره العميل
              </div>
            </div>
            <div className="flex space-x-10 w-full">
              <label className="w-full">
                كود العميل
                <input
                  placeholder="كود العميل"
                  value={formData.clientCode}
                  onChange={onChange}
                  className="w-full border rounded-lg my-2 p-2 invalid:border-pink-500 invalid:text-pink-600
              focus:invalid:border-pink-500 focus:invalid:ring-pink-500"
                  required
                  name="clientCode"
                />
              </label>
            </div>
            <div className="flex space-x-10 w-full">
              <label className="w-full">
                اسم العميل
                <input
                  placeholder="اسم العميل"
                  value={formData.clientName}
                  onChange={onChange}
                  className="w-full border rounded-lg my-2 p-2 invalid:border-pink-500 invalid:text-pink-600
              focus:invalid:border-pink-500 focus:invalid:ring-pink-500"
                  required
                  name="clientName"
                />
              </label>
            </div>
            <div className="flex flex-row justify-center space-x-10 w-full mt-5">
              <div className="w-1/2">
                <Button
                  type="submit"
                  text="تسجيل"
                  isDisabled={
                    !(formData.clientName && formData.clientCode)
                  }
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </form>
  );
};

export default ClientForm;
